import React from "react";
import Spinner from "react-bootstrap/Spinner";

const LoadingTable = () => {
  return (
    <tr
      className="odd"
      style={{
        height: "500px",
        position: "relative",
        backgroundColor: "unset",
      }}
    >
      <td
        valign="top"
        colSpan="8"
        className="dataTables_empty text-center"
        style={{
          position: "absolute",
          top: "50%",
          width: "100%",
          borderTop: "0",
        }}
      >
        <Spinner animation="grow" variant="primary" />
        <Spinner animation="grow" variant="secondary" />
        <Spinner animation="grow" variant="success" />
        <Spinner animation="grow" variant="danger" />
        <Spinner animation="grow" variant="warning" />
        <Spinner animation="grow" variant="info" />
        <Spinner animation="grow" variant="light" />
        <Spinner animation="grow" variant="dark" />
      </td>
    </tr>
  );
};

export default LoadingTable;
